import throttle from "lodash/throttle";
import { useEffect } from "react";

export const useHitBottom = ({
    fetch,
    enabled = true
}: {
    fetch: () => void;
    enabled?: boolean;
}) => {
    useEffect(() => {
        if (!enabled) {
            return;
        }

        const callback = throttle(() => {
            if (
                window.innerHeight + window.scrollY + 100 >=
                document.body.offsetHeight
            ) {
                fetch();
            }
        }, 300);

        window.addEventListener("scroll", callback);

        return () => window.removeEventListener("scroll", callback);
    }, [fetch, enabled]);
};
